module.exports = __webpack_public_path__ + "img/2020-1-1_c35ef95e2.png";